import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';

import { InboxModule } from '../inbox/inbox.module';
import { PushboxLeftNavigationComponent } from './pushbox-left-navigation/pushbox-left-navigation.component';
import { PushboxTaskListComponent } from './pushbox-task-list/pushbox-task-list.component';
import { PushboxComponent } from './pushbox/pushbox.component';

@NgModule({
  declarations: [PushboxTaskListComponent, PushboxComponent, PushboxLeftNavigationComponent],
  imports: [CommonModule, InboxModule, SharedModule],
})
export class PushboxModule {}
